import React from "react";
//import { Modal, Button } from 'react-bootstrap';

const PopupDelete = ({ message, title, modalstatus, btnClickDelete, btnClickClose }) =>{

    return(
    <>
        <div className={modalstatus ? 'modal fade show' : 'modal fade' } id="exampleModalScrollable2" tabindex="-1" aria-labelledby="exampleModalScrollable2" data-bs-keyboard="false" aria-hidden={!modalstatus} style={{ display: modalstatus ? 'block' : 'none' }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title" id="staticBackdropLabel2">{title}</h4>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={btnClickClose}></button>
                    </div>
                    <div className="modal-body">
                        <p>{message}</p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-cancel" data-bs-dismiss="modal" onClick={btnClickClose}>Close</button>
                        <button type="button" className="btn btn-primary" onClick={btnClickDelete}>Delete</button>
                    </div>
                </div>
            </div>
        </div>
        
        {modalstatus && (
            <div className="modal-backdrop fade show"></div>
        )}
    </>
    )
}

export default PopupDelete;